// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j7-0";
export var actionModalContentContainer = "_j7-1";
export var createTagButton = "_j7-2";
export var footerContainer = "_j7-7";
export var fullWidthDivider = "_j7-3";
export var hasCreateTagButton = "_j7-4";
export var noCreateTagButton = "_j7-5";
export var tagsContainer = "_j7-6";
export var tagsModalContentContainer = "_j7-8";